import { PageMeta } from "@/components/PageMeta";
import { GlassPanel } from "@/components/GlassPanel";
import { ContactForm } from "@/components/ContactForm";
import { siteConfig } from "@/config/site";
import { routeSeo } from "@/content/seo";
import "./ContactPage.css";

export function ContactPage() {
  const seo = routeSeo["/contact"];
  return (
    <>
      <PageMeta title={seo.title} description={seo.description} path="/contact" />

      <section className="container page-hero">
        <p className="eyebrow">Contact</p>
        <h1 className="page-hero-title">Talk to Devory</h1>
        <p className="page-hero-lede">
          Whether you have a product question, need help with your Devory Cloud account, or need to
          reach Devory about enterprise, support, security, privacy or legal matters, this form
          reaches a real person.
        </p>
      </section>

      <section className="container section contact-layout">
        <aside className="contact-aside" aria-label="Contact details">
          <p className="eyebrow">A direct conversation</p>
          <h2>Start with the context that matters.</h2>
          <p>
            Share what you are building, where the friction is, and what a useful next step would
            look like. Your note goes directly to the team behind Devory.
          </p>
          <dl className="contact-details">
            <div>
              <dt>Email</dt>
              <dd>
                <a href={`mailto:${siteConfig.contactEmail}`}>{siteConfig.contactEmail}</a>
              </dd>
            </div>
            <div>
              <dt>Best for</dt>
              <dd>Product, enterprise, support, security and partnerships</dd>
            </div>
            <div>
              <dt>Availability</dt>
              <dd>Public self-serve sign-up is open to everyone today</dd>
            </div>
          </dl>
        </aside>
        <GlassPanel as="div" className="contact-form-panel">
          <ContactForm />
        </GlassPanel>
      </section>
    </>
  );
}
